import { finalize, switchMap } from 'rxjs/operators';
import { Component, AfterContentInit, OnDestroy, ElementRef, OnInit } from '@angular/core';

import { PlycaDataService } from '../../../services/plyca.service';

import {
  DivisionDTO,
  DocumentClassDTO,
  TemplateDTO,
  FileDetailsDTO,
  getSimpleIdentifierFromString
} from '../../api/plyca-dtos';
import { DataRetrieverConfig, FieldConfig } from '../../api/contract-notice-dto';
import { DossierService } from '../../dossiers/dossier.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { DocumentService } from '../document.service';
import { CompanyDTO } from '../../api/plyca-dtos-v2';
import { ServiceLocator } from '../../ServiceLocator';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { TreeNode, SelectItem } from 'primeng-lts/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';

@Component({
  selector: 'newTemplate',
  templateUrl: 'newTemplate.template.html'
})
export class newTemplateComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  loading = true;
  dossier: any;
  divisiones: DivisionDTO[];
  rootDivision: TreeNode[];
  model: TemplateModel;
  templateSelectionEnabled = false;
  public documentService: DocumentService;
  tagsParent: string[] = [];
  windowHash: string;


  templates: SelectItem[];
  templateParams: any[];
  filteredParams: any[];
  FILTERED_PARAMETER_NAMES = ['EMPRESADNICIF', 'LOTEID'];
  companySelectionEnabled = false;
  divisionSelectionEnabled = false;

  constructor(
    public dossierService: DossierService,
    public plycaService: PlycaDataService,
    // public documentService: DocumentService,
    public uiService: UIService,
    public helpService: HelpService,
    // public dialogService: DialogService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private translationService: TranslateService,
    private elem: ElementRef,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService
  ) {
    super();
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.dossier = dialogConfig['dossier'];
    this.model = new TemplateModel();
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.NEW_TEMPLATE)
        }
      )));

  }
  ngOnInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.waitService.startWaiting();
    this.initHeaderActions();
    this.loading = false;
    this.waitService.cancelWaiting();
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.cancel',
        'fas fa-1-25x fa-times',
        'btn-secondary',
        true, this.windowHash)

      ,
      () => {
        this.cancel();
      });


    this.subscribe(this.headerActionsService
      .addWindowAction(
        'TemplateGeneration.generateAction',
        'fas fa-1-25x fa-check',
        'btn-primary',
        true, this.windowHash, function () { return this.isTemplateGenerationEnabled(); }.bind(this))

      ,
      () => {
        this.generateTemplate();
      });


  }







  ngAfterContentInit(): void {
    this.subscribe(this.dossierService.getDivisionsTree(this.dossier.identifier),
      rootNode => {
        this.rootDivision = [];
        this.rootDivision.push(this.division2Node(rootNode));
        console.log('divisiones', this.rootDivision);
        this.loading = false;
      });



  }

  division2Node(division: DivisionDTO): TreeNode {
    let icon = 'fa-2x  fa-folder-o ';
    // hack para la descripcion en el tree
    //    division['description'] = division.name;
    let divisionNode: TreeNode = {
      data: division,
      expanded: true,
      label: division.name
      // children: this.children2Nodes(division)
    };
    divisionNode['children'] = this.children2Nodes(division);
    //    division['icono'] = icon;
    return divisionNode;
  }

  children2Nodes(divisionNode: DivisionDTO) {
    let _children = [];
    if (divisionNode.children) {
      divisionNode.children.forEach(child => {
        let tmp = this.division2Node(child);
        _children.push(tmp);
      });
    }
    return _children;
  }

  public isLoaded(): boolean {
    return !this.loading;
  }

  public getBuscadorTipoDocumentosConfig(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.jsonField = 'documentClass';
    config.description = undefined;
    config.fieldStyle = 'plForm-element';
    config.autoSearch = false;
    config.idBuscador = 'DOCUMENTCLASSTEMPLATE';
    config.editable = 'this.model.division&&this.model.division.identifier'
    return config;
  }

  openDivisionSelector(event, overlaypanel: OverlayPanel) {
    overlaypanel.show(event);
  }

  selectDivision(event, overlaypanel: OverlayPanel) {
    console.log('SELECCIONADO DIVISION', event.node);
    this.model.division = event.node.data;
    overlaypanel.hide();
  }

  loadTemplates() {
    this.model.template = undefined;
    this.model.ui = { templates: [] };



    if (this.model
      && this.model.division
      && this.model.division.identifier) {

      if (this.model.documentClass) {
        this.subscribe(this.plycaService.findTemplatesByDocument(
          this.model.documentClass.identifier,
          this.dossier.identifier,
          getSimpleIdentifierFromString(this.model.division.identifier)
        ),
          (param: PaginationDTO<TemplateDTO>) => {
            if (param != null && param.content) {

              this.model.ui.templates = param.content.map((template: TemplateDTO) => {
                return { label: template.description, value: template };
              });
              if (this.model.ui.templates.length === 1) {
                this.model.template = this.model.ui.templates[0].value;
                this.selectTemplate();

              }
            }
          });
      }


    }
  }


  onChangeDivision() {
    this.model.template = undefined;
    this.model.documentClass = undefined;
  }

  selectTemplate(overlaypanel?: OverlayPanel) {

    if (this.model && this.model.template && this.model.template.params) {
      this.templateParams = this.model.template.params.map(param => {
        return { name: param.name, value: '' };
      });
      // FILTRAR PAMETROS QUE QUEREMOS FIJAR (LOTEID, EMPRESADNICIF)
      this.filteredParams = this.filterFixedParameters(this.templateParams);
      this.companySelectionEnabled = this.templateParams.some(
        p => 'EMPRESADNICIF' === p.name
      );
      this.divisionSelectionEnabled = this.templateParams.some(
        p => 'LOTEID' === p.name
      );
    }

    if (overlaypanel) {
      overlaypanel.hide();
    }


  }

  filterFixedParameters(params: any[]) {
    return params.filter(param => {
      return !this.FILTERED_PARAMETER_NAMES.some(p => p === param.name);
    });
  }

  generateTemplate(): void {
    if (this.isTemplateGenerationEnabled()) {

      let params = '';
      let aux = '';
      if (this.model.division) {
        params +=
          aux +
          'division=' +
          getSimpleIdentifierFromString(this.model.division.identifier);
      } else {
        params += aux + 'division=0';
      }
      aux = '&';
      params += aux + 'documentClassId=' + this.model.documentClass.identifier;
      params += aux + 'projectEntityId=' + this.dossier.identifier;
      if (this.templateParams) {
        this.templateParams.forEach(p => {
          switch (p.name) {
            case 'LOTEID':
              if (this.model.division) {
                params +=
                  aux +
                  'LOTEID=' +
                  getSimpleIdentifierFromString(this.model.division.identifier);
                aux = '&';
              }
              break;
            case 'EMPRESADNICIF':
              if (this.model.company) {
                params += aux + p.name + '=' + this.model.company.taxIdentifier;
              }
              break;
            default:
              if (p.value) {
                params += aux + p.name + '=' + p.value;
              }
          }
        });
      }

      this.waitService.startWaiting();

      this.subscribe(this.plycaService
        .generateTemplateByDocumentClass(this.model.template, params).pipe(finalize(() => this.waitService.cancelWaiting())),
        (fileDetails: FileDetailsDTO) => {
          this.documentService.downloadFile(fileDetails);
          this.ref.close();
        },
        err => {
          console.log('Error al generateTemplate', err);
          this.uiService.showMessage(
            'No se ha encontrado plantilla para el documento seleccionado'
          );
        }
      );
      this.templateParams = [];

    }

  }
  ngOnDestroy(): void {

    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);

        this.dialogConfig = null;
        super.ngOnDestroy();
      })));
  }


  cancel() {
    console.log('CERRANDO DIALOGO');
    this.ref.close();
  }

  // configuracion del buscador de empresas
  public getCompanySearchFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.tooltipText = 'Seleccionar empresa adjudicataria';
    config.jsonField = 'company';
    config.description = 'Tercero:';
    config.autoSearch = false;
    config.idBuscador = 'com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL';
    config.columnStyle = 'col-12';
    return config;
  }

  isDivisionSelectionEnabled() {
    return this.divisionSelectionEnabled;
  }

  isCompanySelectionEnabled() {
    return this.companySelectionEnabled;
  }

  isTemplateGenerationEnabled() {
    return (
      this.model.documentClass &&
      this.model.template &&
      (!this.isCompanySelectionEnabled() ||
        (this.isCompanySelectionEnabled() && this.model.company)) &&
      (!this.isDivisionSelectionEnabled() ||
        (this.isDivisionSelectionEnabled() && this.model.division))
    );
  }



  public getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'division';
    config.fieldStyle = 'plForm-element';
    config.idBuscador = this.dossier.identifier;
    return config;
  }



  public getTemplatesConfig(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DROPDOWN';
    config.dinamicOptionsActive = true;
    config.jsonField = 'template';
    config.fieldStyle = 'plForm-element';
    config.dataConfig = new DataRetrieverConfig();
    config.dataConfig.jsonPath = 'ui.templates';
    config.editable = 'this.model.documentClass';
    return config;
  }


}

class TemplateModel {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  template: TemplateDTO;
  // para los parametros fijos
  company: CompanyDTO;
  ui: { templates: any };
}
